import { render, staticRenderFns } from "./ButtonShare.vue?vue&type=template&id=24ef60d6&scoped=true"
import script from "./ButtonShare.vue?vue&type=script&lang=js"
export * from "./ButtonShare.vue?vue&type=script&lang=js"
import style0 from "./ButtonShare.vue?vue&type=style&index=0&id=24ef60d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef60d6",
  null
  
)

export default component.exports